import { render, staticRenderFns } from "./Ditu.vue?vue&type=template&id=71075ec0&scoped=true&"
import script from "./Ditu.vue?vue&type=script&lang=js&"
export * from "./Ditu.vue?vue&type=script&lang=js&"
import style0 from "./Ditu.vue?vue&type=style&index=0&id=71075ec0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71075ec0",
  null
  
)

export default component.exports